export default "__VITE_ASSET__edNhao$C__"